import {GetStayLetterLink} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetStayLetterLink} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetStayLetterUrl = (): GetStayLetterLink =>
	new RemoteGetStayLetterLink(
		makeBFFApiUrl(ExternalLinkPoint.stayLetter),
		makeAuthorizeHttpClientDecorator(),
	);
